import { useStore } from '@tanstack/react-form';
import { useFieldContext } from '.';
import { FieldErrors } from './FieldErrors';
import FileInput from '../FileInput';

type FileFieldProps = {
  label: React.ReactNode;
};

export const FileField = (props: FileFieldProps) => {
  const field = useFieldContext<File>();
  const hasTriedToSubmit = useStore(
    field.form.store,
    (state) => state.submissionAttempts > 0
  );
  return (
    <FileInput
      value={field.state.value}
      onChange={(file) => field.handleChange(file)}
      label={props.label}
      error={
        field.state.meta.isTouched || hasTriedToSubmit
          ? field.state.meta.errors.length > 0
          : false
      }
      helperText={<FieldErrors meta={field.state.meta} />}
    />
  );
};
